// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__31lga","options":"AnswerScale_options__2pP4w","selected":"AnswerScale_selected__24JgT"};